import Vue from 'vue'
import menus from './menus';
import VueRouter from 'vue-router'
import Layout from '../views/layout/layout';

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'layout',
    component: Layout,
    redirect: '/home',
    children: menus
  },
]

const router = new VueRouter({
  routes
})

export default router
